/*
 * Module for the topic Categories.  Assumes this.categoryOptions is already synced before show() and that it has at least one entry
 */

define([
  "backbone",
  "marionette",
  "underscore",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesAddModal/categoryAddModalView",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesModel",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Backbone,
  Marionette,
  _,
  Messenger,
  TopicCategoriesView,
  TopicCategoriesModel,
  KbMenuModel,
) {
  var TopicCategoriesModalAddController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicCategories";
      this.region = options.region;
    },
    show: function (categories, categoryOptions, catIdToValueIdsSearchResultMap) {
      this.categories = categories;

      var cvMap = new Map();
      categories.forEach(function (cat) {
        cvMap.set(parseInt(cat.get("categoryValueId")), cat.get("categoryValue"));
      });

      var filteredCategories = new TopicCategoriesModel.topicCategoriesBk();

      categoryOptions.forEach(function (cat) {
        var model = new TopicCategoriesModel.topicCategoryBk({
          categoryId: cat.get("categoryId"),
          categoryName: cat.get("categoryName"),
          description: cat.get("description"),
        });
        // Copy the category values, because they are being modified to specify whether they are shown in the list
        var categoryValues = new KbMenuModel.categoryValues(
          cat.getValues().toJSON({ saving: true }),
          { parse: true },
        );

        model.set("categoryValues", categoryValues);
        var allValuesUsed = true;
        categoryValues.forEach(function (catValue) {
          if (cvMap.has(catValue.get("categoryValueId"))) {
            catValue.set("showInList", false);
          } else {
            allValuesUsed = false;
          }
          if (catIdToValueIdsSearchResultMap.has(cat.get("categoryId"))) {
            // there is a list of values that matched search text in this category
            if (
              catIdToValueIdsSearchResultMap
                .get(cat.get("categoryId"))
                .includes(catValue.get("categoryValueId"))
            ) {
              catValue.set("includedInSearchResult", true);
            } else {
              catValue.set("includedInSearchResult", false);
            }
          }
        });
        model.set("allValuesUsed", allValuesUsed);
        filteredCategories.add(model);
      });

      this.view = new TopicCategoriesView.accordionView({ collection: filteredCategories });
      this.view.on(
        "topic:categories:addModal:add",
        function (categoryKey) {
          Messenger.vent.trigger("topic:categories:multi-select:add", categoryKey);
        },
        this,
      );
      this.view.on(
        "topic:categories:addModal:remove",
        function (categoryKey) {
          Messenger.vent.trigger("topic:categories:multi-select:remove", categoryKey);
        },
        this,
      );

      // // categories.sort();
      this.showRegion(this.view, { loading: true, entity: filteredCategories });
    },
  });

  return TopicCategoriesModalAddController;
});
